'use client';

import Script from 'next/script';

interface GoogleAnalyticsProps {
  gaId: string;
}

const GoogleAnalytics = ({ gaId }: GoogleAnalyticsProps) => {
  return (
    <>
      <Script data-component-id="src/components/analytics/GoogleAnalytics.tsx:12:6" data-component-path="src/components/analytics/GoogleAnalytics.tsx" data-component-line="12" data-component-end-line="15" data-component-file="GoogleAnalytics.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%7D"
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
      />
      <Script data-component-id="src/components/analytics/GoogleAnalytics.tsx:16:6" data-component-path="src/components/analytics/GoogleAnalytics.tsx" data-component-line="16" data-component-end-line="29" data-component-file="GoogleAnalytics.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%2C%22id%22%3A%22google-analytics%22%7D"
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gaId}', {
              page_path: window.location.pathname,
            });
          `,
        }}
      />
    </>
  );
};

export default GoogleAnalytics;
